import { ActionButton, AddIcon, useCreateWorkActions } from '@diana/core';

export function StartWorkButton(props: { openInSidePeek: boolean; flowId: string }) {
  const { openInSidePeek, flowId } = props;

  const createWork = useCreateWorkActions({
    flowId: flowId,
    openInSidePeek,
  });

  return createWork.actions.length ? (
    <ActionButton
      actions={createWork.actions}
      startIcon={<AddIcon color="inherit" />}
      preventUseMonoActionIcon
      sx={({ spacing }) => ({ height: spacing(4) })}
    >
      {createWork.displayName}
    </ActionButton>
  ) : null;
}
